import appLogo from "../assets/app_logo_no_text.png";

export interface CollectionSlide {
    title: string;
    description: string;
    image: string;
}

export const collectionData: CollectionSlide[] = [
    {
        title: "Shitje Blerje",
        description: "Ju mund të shitni apo bleni rroba duke kontaktuar me shitësin apo blerësin",
        image: appLogo,
    },
    {
        title: "Me Qira",
        description: "Ju mund të merrni apo lëshoni rrobat tuaja me qira sipas marrëveshjes",
        image: appLogo,
    },
    {
        title: "Falas",
        description: "Ju poashtu mund të dhuroni apo merrni rroba falas",
        image: appLogo,
    },
];
